// packages/services/src/shopService.ts
import { PaginatedResponse, Shop } from '@cabukaka/types'
import { dataService } from './core/dataService';
import axios from 'axios';
import { getConfig } from '@cabukaka/config/index';
import { mapMongoDocs } from '@cabukaka/utils/index';

export const shopService = {
    get baseService() {
        return dataService<Shop>("shops");
    },

    getShopById: async (id: string, token?: string): Promise<Shop | null> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get<Shop>(`${apiUrl}/shops/${id}`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            return res.data;
        } catch (error) {
            console.error(error);
            return null;
        }
    },

    getShops: async (token?: string, page: number = 1, limit: number = 20): Promise<PaginatedResponse<Shop>> => {
        return shopService.baseService.getAll({ page, limit }, token);
    },


    

    getShopsBySectorSlug: async (slug: string, token?: string, page: number = 1, limit: number = 20): Promise<PaginatedResponse<Shop>> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get<PaginatedResponse<Shop>>(`${apiUrl}/shops/sector/slug/${slug}`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {},
                params: { page, limit }
            });
            return {
                ...res.data,

                data: mapMongoDocs(res.data.data),
            };
        } catch (error) {
            console.error(error);
            return { data: [], total: 0, pages: 0 };
        }
    },

    getShopsByCity: async (city: string, token?: string, page: number = 1, limit: number = 20): Promise<PaginatedResponse<Shop>> => {
        return shopService.baseService.getAll({ city, page, limit }, token);
    },
};